import { render, staticRenderFns } from "./RewardsProgramSolid.vue?vue&type=template&id=57875d5e&"
import script from "./RewardsProgramSolid.vue?vue&type=script&lang=ts&"
export * from "./RewardsProgramSolid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports